import script from "./login-forget.vue?vue&type=script&lang=ts&setup=true"
export * from "./login-forget.vue?vue&type=script&lang=ts&setup=true"

import "./login-forget.vue?vue&type=style&index=0&id=5fbc22dc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fbc22dc"]])

export default __exports__